import type { GameId, Stamps } from './types';
import { loadJson, saveJson } from './storage';

const EMPTY: Stamps = { clear: false, skill: false, mastery: false };

export function allStamps(): Record<string, Stamps> {
  return loadJson<Record<string, Stamps>>('stamps', {});
}

export function getStamps(id: GameId): Stamps {
  return { ...EMPTY, ...allStamps()[id] };
}

export function grantStamps(id: GameId, next: Partial<Stamps>) {
  const all = allStamps();
  const cur = { ...EMPTY, ...all[id] };
  all[id] = {
    clear: cur.clear || !!next.clear,
    skill: cur.skill || !!next.skill,
    mastery: cur.mastery || !!next.mastery,
  };
  saveJson('stamps', all);
  return all[id];
}

export function stampCount() {
  return Object.values(allStamps()).reduce((n, s) => n + Number(s.clear) + Number(s.skill) + Number(s.mastery), 0);
}
